import { render, staticRenderFns } from "./OlabFooter.vue?vue&type=template&id=378cacb1&scoped=true&"
import script from "./OlabFooter.vue?vue&type=script&lang=js&"
export * from "./OlabFooter.vue?vue&type=script&lang=js&"
import style0 from "./OlabFooter.vue?vue&type=style&index=0&id=378cacb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378cacb1",
  null
  
)

export default component.exports